<script>

	import ArticleEntry from '@/components/ArticleEntry'
	import BlogishEntries from '@/components/BlogishEntries'
	import moment from 'moment'

	export default {
		routeConfig: {
			path: ':slug'
		},
		render () {
			return (
				<BlogishEntries
					variables={{
						section: 'blog'
					}}
					render={({ ready, entries }) => {
						if(!ready) {
							return null
						}
						this.entry = entries.find((entry) => entry.slug === this.$route.params.slug)
						if(!this.entry) {
							this.$router.push({ name: 'blog', query: { statusCode: 404 } })
						}
						return (
							<ArticleEntry
								entry={this.entry}
								byline={(entry) => (
									<p class="byline">
										By {entry.author.title}
										&nbsp; | &nbsp;
										{moment(entry.postDate).format('LL')}
									</p>
								)}
								shareTools={true}
							/>
						)
					}}
				/>
			)
		}
	}

</script>

<style scoped>
	.byline {
		text-transform:uppercase; font-family:'oswald';
	}
</style>



// WEBPACK FOOTER //
// src/routes/blog/entry.vue